(function () {
  'use strict';
  var box = document.querySelector('[data-stash-box]');
  if (!box) return;
  var form = box.closest('form');
  var choice = box.querySelector('[data-stash-choice]');
  var status = box.querySelector('[data-stash-status]');
  var error = box.querySelector('[data-stash-error]');
  var config = JSON.parse(box.querySelector('[data-stash-config]').textContent);
  var checkout = form.querySelector('[name="checkout"]');
  var route = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var busy = false;
  var selectionSync=Promise.resolve();
  var preorderNotices=Array.from(form.querySelectorAll('.cart__preorder-notice span')).map(function(node){return {node:node,html:node.innerHTML};});
  function render() {
    form.classList.toggle('cchw-stash-selected',choice.checked);
    box.dataset.active = String(choice.checked);
    status.hidden = !choice.checked;
    checkout.value = choice.checked ? config.stashCheckout : config.checkout;
    preorderNotices.forEach(function(notice){if(choice.checked)notice.node.textContent=config.preorder;else notice.node.innerHTML=notice.html;});
  }
  choice.addEventListener('change',function () {
    error.hidden=true;render();
    if(choice.checked)return;
    form.classList.add('cchw-stash-syncing');checkout.disabled=true;
    selectionSync=request(route+'cart.js').then(function(cart){
      var payload={attributes:{cchw_stash:''}};
      if((cart.discount_codes||[]).some(function(d){return d.code&&d.code.toUpperCase()===config.code;}))payload.discount=codes(cart).join(',');
      return request(route+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
    }).then(function(cart){document.dispatchEvent(new CustomEvent('cchw:cart-updated',{detail:{cart:cart}}));}).catch(function(){error.textContent=config.error;error.hidden=false;}).finally(function(){checkout.disabled=false;form.classList.remove('cchw-stash-syncing');});
  });
  function request(url, options) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); },15000);
    return fetch(url,Object.assign({credentials:'same-origin',headers:{Accept:'application/json'},signal:controller.signal},options)).then(function (response) {
      if (!response.ok) throw new Error(config.error);return response.json();
    }).finally(function () { clearTimeout(timer); });
  }
  function codes(cart) {
    return (cart.discount_codes || []).map(function (discount) { return discount.code; }).filter(function (code) { return code && code.toUpperCase() !== config.code; });
  }
  form.addEventListener('submit',function (event) {
    var submitter = event.submitter || document.activeElement;
    if (!submitter || submitter.name !== 'checkout') return;
    event.preventDefault();event.stopImmediatePropagation();
    if (busy) return;
    busy = true;checkout.disabled = true;choice.disabled = true;checkout.value = config.working;error.hidden = true;
    var settle = form.cchwFlushQuantities ? form.cchwFlushQuantities() : Promise.resolve();
    Promise.all([settle,selectionSync]).then(function () { return request(route+'cart.js'); }).then(function (cart) {
      var discounts = codes(cart);
      if (choice.checked) discounts.push(config.code);
      var note = form.querySelector('[name="note"]');
      var payload = {attributes:{cchw_stash:choice.checked?'yes':''}};
      if (note) payload.note = note.value;
      if (choice.checked || (cart.discount_codes || []).some(function (discount) { return discount.code && discount.code.toUpperCase()===config.code; })) payload.discount = discounts.join(',');
      return request(route+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)}).then(function (updated) {
        if (!updated.item_count) throw new Error(config.error);
        var target = route+'checkout';
        if (discounts.length) target += '?discount='+encodeURIComponent(discounts.join(','));
        window.location.assign(target);
      });
    }).catch(function () {
      busy = false;checkout.disabled = false;choice.disabled = false;error.textContent = config.error;error.hidden = false;render();
    });
  },true);
  render();
})();
